export class TaskDefinitionOfDone {

  public id: number;
  public task_id: number;
  public definition_of_dones_id: any;


  public constructor(id: number, task_id: number, definition_of_dones_id: number[]) {
    this.id = id;
    this.task_id = task_id;
    this.definition_of_dones_id = definition_of_dones_id;
  }

  public addDodId(dodId: number, not_relevant: boolean) {
    this.definition_of_dones_id.push({'definition_of_done_id': dodId, 'not_relevant': not_relevant});
  }

  public removeDodId(dodId: number) {
    const data = this.definition_of_dones_id;
    const val = dodId;
    const index = data.findIndex(obj => obj.definition_of_done_id === val);
    if (index >= 0) {
      this.definition_of_dones_id.splice(index, 1);
    }
  }
}
